import React, { useState } from 'react';
import breakfastImage from '../assets/breakfast.jpg';
import lunchImage from '../assets/lunch.jpg';
import dinnerImage from '../assets/meal.jpg';
import menuImage from '../assets/menu.png';

// Custom styles for FoodServed component
const styles = `
.food-served-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 80px 0;
}

/* Menu Modal Styles */
.menu-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
    padding: 20px;
}

.menu-modal-overlay.active {
    opacity: 1;
    visibility: visible;
}

.menu-modal-content {
    position: relative;
    max-width: 60%;
    max-height: 90vh;
    background: white;
    border-radius: 24px;
    padding: 20px;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3);
    transform: scale(0.8) translateY(30px);
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.menu-modal-overlay.active .menu-modal-content {
    transform: scale(1) translateY(0);
}

.menu-modal-close {
    position: absolute;
    top: -15px;
    right: -15px;
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #FF6B6B 0%, #EE5A5A 100%);
    border: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 8px 25px rgba(238, 90, 90, 0.4);
    transition: all 0.3s ease;
    z-index: 10;
}

.menu-modal-close:hover {
    transform: scale(1.1) rotate(90deg);
    box-shadow: 0 10px 30px rgba(238, 90, 90, 0.5);
}

.menu-modal-close svg {
    width: 24px;
    height: 24px;
    stroke: white;
    stroke-width: 2.5;
}

.menu-modal-image-wrapper {
    position: relative;
    overflow-y: auto;
    max-height: 85vh;
    border-radius: 16px;
    /* Custom scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: rgba(90, 52, 17, 0.5) #f1f1f1;
}

.menu-modal-image-wrapper::-webkit-scrollbar {
    width: 8px;
}

.menu-modal-image-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 8px;
}

.menu-modal-image-wrapper::-webkit-scrollbar-thumb {
    background: rgba(90, 52, 17, 0.5);
    border-radius: 8px;
}

.menu-modal-image {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 16px;
}

.menu-modal-header {
    text-align: center;
    margin-bottom: 15px;
}

.menu-modal-title {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.8rem;
    font-weight: 700;
    color: #5A3411;
    margin: 0;
}

.menu-modal-subtitle {
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    color: rgba(90, 52, 17, 0.7);
    margin-top: 5px;
}

/* Card hover effect for clickability */
.food-served-card {
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.food-served-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
}

.food-served-card::after {
    content: 'View Menu';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.8);
    background: rgba(255, 255, 255, 0.95);
    color: #5A3411;
    font-family: 'Quicksand', sans-serif;
    font-weight: 700;
    font-size: 1.1rem;
    padding: 12px 28px;
    border-radius: 50px;
    opacity: 0;
    transition: all 0.3s ease;
    pointer-events: none;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.food-served-card:hover::after {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
}

@media (max-width: 767.98px) {
    .menu-modal-content {
        max-width: 95%;
        padding: 15px;
        border-radius: 20px;
    }
    
    .menu-modal-close {
        width: 44px;
        height: 44px;
        top: -12px;
        right: -12px;
    }
    
    .menu-modal-close svg {
        width: 20px;
        height: 20px;
    }
    
    .menu-modal-title {
        font-size: 1.5rem;
    }
    
    .menu-modal-subtitle {
        font-size: 0.9rem;
    }
    
    .menu-modal-image {
        border-radius: 12px;
    }
    
    .food-served-card::after {
        font-size: 0.95rem;
        padding: 10px 22px;
    }
}

@media (max-width: 575.98px) {
    .menu-modal-content {
        padding: 12px;
        border-radius: 16px;
    }
    
    .menu-modal-close {
        width: 40px;
        height: 40px;
        top: -10px;
        right: -10px;
    }
    
    .menu-modal-title {
        font-size: 1.3rem;
    }
    
    .menu-modal-image {
        border-radius: 10px;
    }
    
    .food-served-card::after {
        font-size: 0.85rem;
        padding: 8px 18px;
    }
}

.food-served-content-wrapper {
    position: relative;
    z-index: 3;
}

/* Main Heading */
.food-served-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.8rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 25px;
}

/* Content Text */
.food-served-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    font-weight: 500;
    color: rgba(90, 52, 17, 0.8);
    line-height: 1.75;
    margin-bottom: 40px;
    text-align: justify;
}

/* Meal Cards Container */
.food-served-cards {
    display: flex;
    gap: 30px;
    margin-bottom: 40px;
}

/* Individual Meal Card */
.food-served-card {
    flex: 1;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    min-height: 350px;
}

.food-served-card-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
}

/* Card Content Overlay */
.food-served-card-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 60%, transparent 100%);
    padding: 80px 20px 25px 20px;
    color: white;
}

.food-served-card-title {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 8px;
    color: white;
}

.food-served-card-description {
    font-family: 'Quicksand', sans-serif;
    font-size: 0.95rem;
    font-weight: 400;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
}

/* Bottom Note Section */
.food-served-note {
    background-color: #F5F1E9;
    border-radius: 16px;
    padding: 25px 30px;
}

.food-served-note-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.05rem;
    font-weight: 500;
    color: rgba(90, 52, 17, 0.85);
    line-height: 1.7;
    margin: 0;
    text-align: center;
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .food-served-section {
        padding: 70px 0;
    }
    
    .food-served-heading {
        font-size: 2.5rem;
    }
    
    .food-served-text {
        font-size: 1.05rem;
    }
    
    .food-served-cards {
        gap: 25px;
    }
    
    .food-served-card {
        min-height: 320px;
    }
    
    .food-served-card-title {
        font-size: 1.4rem;
    }
}

@media (max-width: 991.98px) {
    .food-served-section {
        padding: 60px 0;
    }
    
    .food-served-heading {
        font-size: 2.2rem;
    }
    
    .food-served-text {
        font-size: 1rem;
        margin-bottom: 35px;
    }
    
    .food-served-cards {
        gap: 20px;
    }
    
    .food-served-card {
        min-height: 300px;
        border-radius: 16px;
    }
    
    .food-served-card-title {
        font-size: 1.3rem;
    }
    
    .food-served-card-description {
        font-size: 0.9rem;
    }
    
    .food-served-note {
        padding: 22px 25px;
    }
    
    .food-served-note-text {
        font-size: 1rem;
    }
}

@media (max-width: 767.98px) {
    .food-served-section {
        padding: 50px 0;
    }
    
    .food-served-heading {
        font-size: 1.8rem;
        margin-bottom: 20px;
    }
    
    .food-served-text {
        font-size: 0.95rem;
        line-height: 1.7;
        margin-bottom: 30px;
    }
    
    .food-served-cards {
        flex-direction: column;
        gap: 20px;
    }
    
    .food-served-card {
        min-height: 280px;
        border-radius: 16px;
    }
    
    .food-served-card-content {
        padding: 60px 18px 20px 18px;
    }
    
    .food-served-card-title {
        font-size: 1.35rem;
        margin-bottom: 6px;
    }
    
    .food-served-card-description {
        font-size: 0.9rem;
    }
    
    .food-served-note {
        padding: 20px 22px;
        border-radius: 14px;
    }
    
    .food-served-note-text {
        font-size: 0.95rem;
        text-align: left;
    }
}

@media (max-width: 575.98px) {
    .food-served-section {
        padding: 40px 0;
    }
    
    .food-served-heading {
        font-size: 1.5rem;
        margin-bottom: 18px;
    }
    
    .food-served-text {
        font-size: 0.9rem;
        line-height: 1.65;
        margin-bottom: 25px;
    }
    
    .food-served-cards {
        gap: 18px;
    }
    
    .food-served-card {
        min-height: 250px;
        border-radius: 14px;
    }
    
    .food-served-card-content {
        padding: 50px 15px 18px 15px;
    }
    
    .food-served-card-title {
        font-size: 1.2rem;
    }
    
    .food-served-card-description {
        font-size: 0.85rem;
    }
    
    .food-served-note {
        padding: 18px 18px;
        border-radius: 12px;
    }
    
    .food-served-note-text {
        font-size: 0.9rem;
        line-height: 1.6;
    }
}

@media (max-width: 400px) {
    .food-served-section {
        padding: 35px 0;
    }
    
    .food-served-heading {
        font-size: 1.3rem;
    }
    
    .food-served-text {
        font-size: 0.85rem;
    }
    
    .food-served-cards {
        gap: 15px;
    }
    
    .food-served-card {
        min-height: 220px;
        border-radius: 12px;
    }
    
    .food-served-card-title {
        font-size: 1.1rem;
    }
    
    .food-served-card-description {
        font-size: 0.8rem;
    }
    
    .food-served-note {
        padding: 15px 15px;
    }
    
    .food-served-note-text {
        font-size: 0.85rem;
    }
}
`;

const FoodServed = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const meals = [
        {
            image: breakfastImage,
            title: "Breakfast",
            description: "Starting the day the healthy way."
        },
        {
            image: lunchImage,
            title: "Nutritious Lunch",
            description: "Every day brings new, fresh, and healthy choices."
        },
        {
            image: dinnerImage,
            title: "Hot Evening Meal",
            description: "Wholesome, freshly made meals for cosy tea time moments."
        }
    ];

    const openModal = () => {
        setIsModalOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setIsModalOpen(false);
        document.body.style.overflow = 'auto';
    };

    // Close modal on Escape key
    React.useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                closeModal();
            }
        };

        if (isModalOpen) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isModalOpen]);

    return (
        <>
            <style>{styles}</style>
            <section className="food-served-section">
                <div className="container">
                    <div className="food-served-content-wrapper">
                        {/* Main Heading */}
                        <h2 className="food-served-heading">What We Provide</h2>

                        {/* Intro Text */}
                        <p className="food-served-text">
                            We cater for all dietary needs, including allergies, intolerances, and cultural preferences, working closely with parents and carers to ensure meals are safe, balanced, and enjoyable. From weaning babies to supporting older children's independence, our approach helps children explore tastes, develop healthy habits, and grow with confidence.
                        </p>

                        {/* Meal Cards */}
                        <div className="food-served-cards">
                            {meals.map((meal, index) => (
                                <div
                                    key={index}
                                    className="food-served-card"
                                    onClick={openModal}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => e.key === 'Enter' && openModal()}
                                >
                                    <img
                                        src={meal.image}
                                        alt={meal.title}
                                        className="food-served-card-image"
                                    />
                                    <div className="food-served-card-content">
                                        <h3 className="food-served-card-title">{meal.title}</h3>
                                        <p className="food-served-card-description">{meal.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Bottom Note */}
                        <div className="food-served-note">
                            <p className="food-served-note-text">
                                A snack station will be accessible in every room, featuring a varied rotation of fresh fruits and vegetables along with water.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Menu Modal */}
            <div
                className={`menu-modal-overlay ${isModalOpen ? 'active' : ''}`}
                onClick={closeModal}
            >
                <div
                    className="menu-modal-content"
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        className="menu-modal-close"
                        onClick={closeModal}
                        aria-label="Close menu"
                    >
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>

                    <div className="menu-modal-image-wrapper">
                        <img
                            src={menuImage}
                            alt="Our Menu"
                            className="menu-modal-image"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default FoodServed;
